module.exports = __webpack_public_path__ + "media/assets/images/category/FreeEcards@2x-55810a119d0e931274b63997b1ce6ebc.png";